import { Action } from 'redux';

import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { UploadContentInProgressAction, UploadContentProgressActionsTypes, UploadContentRemoveAction } from '../actions/UploadContentProgressActions';

export type UploadContentProgress = UploadContentInProgressAction;

export interface UploadContentState {
  readonly uploads: Map<string, UploadContentProgress>;
}

const defaultState: UploadContentState = {
  uploads: new Map()
};

const isInProgressAction = isActionFactory<UploadContentInProgressAction>(UploadContentProgressActionsTypes.IN_PROGRESS);
const isCompleteAction = isActionFactory<UploadContentInProgressAction>(UploadContentProgressActionsTypes.COMPLETE);
const isRemoveAction = isActionFactory<UploadContentRemoveAction>(UploadContentProgressActionsTypes.REMOVE_UPLOAD);

export function uploadContentReducer(previousState: UploadContentState = defaultState, action: Action): UploadContentState {
  if (isInProgressAction(action) || isCompleteAction(action)) {
    const updatedAction = {
      ...previousState.uploads.get(action.id),
      ...action
    };
    const updatedUploads = new Map(previousState.uploads);
    updatedUploads.set(action.id, updatedAction);
    return {
      ...previousState,
      uploads: updatedUploads
    };
  }

  if (isRemoveAction(action)) {
    const updatedUploads = new Map(previousState.uploads);
    updatedUploads.delete(action.id);
    return {
      ...previousState,
      uploads: updatedUploads
    };
  }

  return previousState;
}
